import { isRouteErrorResponse } from 'react-router-dom';

export const getErrorMessage = (error: unknown): string => {
  if (isRouteErrorResponse(error)) {
    // Ошибка от React Router
    return error.statusText || error.data?.message || `Ошибка ${error.status}`;
  }

  if (error instanceof Error) {
    // Обычная ошибка JavaScript
    return error.message || 'Произошла неизвестная ошибка';
  }

  if (typeof error === 'string') {
    return error;
  }

  return 'Произошла неизвестная ошибка';
};
